import { render, staticRenderFns } from "./SelectBuilding.vue?vue&type=template&id=64061600&"
import script from "./SelectBuilding.vue?vue&type=script&lang=js&"
export * from "./SelectBuilding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kristiankalva/Local Sites/ensign-boligprosjekter/app/public/wp-content/plugins/ensign-boligprosjekter/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64061600')) {
      api.createRecord('64061600', component.options)
    } else {
      api.reload('64061600', component.options)
    }
    module.hot.accept("./SelectBuilding.vue?vue&type=template&id=64061600&", function () {
      api.rerender('64061600', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SelectBuilding.vue"
export default component.exports